export default __webpack_public_path__ + "static/media/KatieC.bc3e2579.png";